import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  
  username: string = '';
  useremail: string = '';
  roles: string[] = [];

  setUser(name: string, email: string) {
    this.username = name;
    this.useremail = email;
  }

  setRoles(roles: string[]) {
    this.roles = roles;
  }
}
